import { Divider, Select } from "antd";
import { useEffect, useState } from "react";

import { filterSelectValidOptions } from "@/modules/select";

import ComboBoxCustomEntry from "./ComboBoxCustomEntry";

const ComboBox = ({
  initialOptions = [],
  onChange = () => {},
  loading = false,
  disabled = false,
  placeholder = "",
  customEntryPlaceholder = "",
  ...rest
}) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState(initialOptions);

  const addValueToOptions = (value) => {
    if (!initialOptions.some((option) => option.value === value)) {
      setOptions([...initialOptions, { label: value, value }]);
    }
  };

  const onAddCustomValue = (customValue) => {
    addValueToOptions(customValue);
    onChange(customValue);
    setOpen(false);
  };

  useEffect(() => setOptions(initialOptions), [initialOptions]);

  return (
    <Select
      className="combobox"
      options={filterSelectValidOptions(options)}
      open={open}
      disabled={disabled}
      onOpenChange={setOpen}
      onChange={onChange}
      showSearch={{
        optionFilterProp: "children",
        filterOption: (input, option) => {
          option.label.toLowerCase().includes(input.toLowerCase());
        },
        filterSort: (optionA, optionB) => {
          optionA.label
            .toLowerCase()
            .localeCompare(optionB.label.toLowerCase());
        },
      }}
      loading={loading}
      placeholder={placeholder}
      popupRender={(menu) => (
        <div className="combobox-dropdownRender">
          {menu}
          <Divider style={{ margin: "8px 0" }} />
          <ComboBoxCustomEntry
            placeholder={customEntryPlaceholder}
            onAddCustomValue={onAddCustomValue}
          />
        </div>
      )}
      {...rest}
    />
  );
};

export default ComboBox;
